var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from 'react';
import lazyLoad from '../core/helper/lazyLoad';
import { HTMLRenderer } from '../renderer/HTMLRenderer';
var EditableEditor = lazyLoad(function () { return import('./EditableEditor'); });
var Editor = function (_a) {
    var _b;
    var cellPlugins = _a.cellPlugins, readOnly = _a.readOnly, value = _a.value, onChange = _a.onChange, dndBackend = _a.dndBackend, blurGateDisabled = _a.blurGateDisabled, defaultDisplayMode = _a.defaultDisplayMode, languages = _a.languages, _c = _a.lang, lang = _c === void 0 ? (_b = languages === null || languages === void 0 ? void 0 : languages[0].lang) !== null && _b !== void 0 ? _b : 'default' : _c, pluginsWillChange = _a.pluginsWillChange, cellSpacing = _a.cellSpacing, rest = __rest(_a, ["cellPlugins", "readOnly", "value", "onChange", "dndBackend", "blurGateDisabled", "defaultDisplayMode", "languages", "lang", "pluginsWillChange", "cellSpacing"]);
    // mount the component always in readonly, to avoid problems with SSR
    var _d = __read(useState(true), 2), renderReadOnly = _d[0], setRenderReadOnly = _d[1];
    useEffect(function () {
        setRenderReadOnly(readOnly);
    }, [readOnly]);
    return renderReadOnly ? (React.createElement(HTMLRenderer, { value: value, cellPlugins: cellPlugins, lang: lang, cellSpacing: cellSpacing })) : (React.createElement(EditableEditor, __assign({ fallback: React.createElement(HTMLRenderer, { value: value, cellPlugins: cellPlugins, lang: lang, cellSpacing: cellSpacing }), pluginsWillChange: pluginsWillChange, cellPlugins: cellPlugins, value: value, onChange: onChange, dndBackend: dndBackend, blurGateDisabled: blurGateDisabled, defaultDisplayMode: defaultDisplayMode, lang: lang, languages: languages, cellSpacing: cellSpacing }, rest)));
};
export default Editor;
//# sourceMappingURL=Editor.js.map